import React from 'react'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import EditOutlinedIcon from 'components/material-symbol/icons/Edit'
import EventOutlinedIcon from 'components/material-symbol/icons/Event'
import AddToCalendarButton from 'components/add-to-calendar-button'
import ModifySessionDialog from 'components/modify-session-dialog'
import { makeCalendarEvent } from './utils'
import { ActionsWrapper, useStyles } from './styles'

const SessionActions = ({ booking, onReschedule }) => {
  const classes = useStyles()
  const { isCanceled } = booking

  return (
    <ActionsWrapper>
      {!isCanceled && (
        <Tooltip title="Add to calendar">
          <AddToCalendarButton
            className={classes.borderedActionButton}
            aria-label="Add to calendar"
            icon={<EventOutlinedIcon fontSize="small" fill={0} />}
            event={makeCalendarEvent(booking)}
          />
        </Tooltip>
      )}

      <ModifySessionDialog
        trigger={
          <Tooltip title="Modify session">
            <IconButton
              className={classes.borderedActionButton}
              aria-label="Modify session"
            >
              <EditOutlinedIcon fontSize="small" fill={0} />
            </IconButton>
          </Tooltip>
        }
        onSuccess={onReschedule}
        booking={booking}
      />
    </ActionsWrapper>
  )
}

export default SessionActions
